import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
import 'bootstrap/dist/css/bootstrap.min.css';
import registerServiceWorker from './registerServiceWorker';
import './_Content/css/eco-template.css';
import './Util/MomentConfig.js';
import base64 from 'base-64'

ReactDOM.render(<Router />, document.getElementById('root'));
registerServiceWorker();

if (localStorage.getItem("CodUsuario") == null) {
    if (window.location.href.indexOf("/erro") == -1 && window.location.href.toLowerCase().indexOf("/validar-login") == -1)
        window.location = "/erro";
}
else {
    if (isNaN(localStorage.getItem("CodUsuario"))) {
        localStorage.setItem("CodUsuario", base64.decode(localStorage.getItem("CodUsuario")));
    }
}






// WEBPACK FOOTER //
// ./src/index.js